import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { SkeletonGroupSkin } from '../SkeletonGroup';

export interface SkeletonLineUniDriver extends BaseUniDriver {
  /**
   * Gets the width
   */
  getWidth(): Promise<string | null>;
  /**
   * Gets the skin
   */
  getSkin(): Promise<SkeletonGroupSkin | null>;
}

export const skeletonLineDriverFactory = (
  base: UniDriver,
): SkeletonLineUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    getWidth: () => base.attr('data-width'),

    getSkin: () => base.attr('data-skin') as Promise<SkeletonGroupSkin | null>,
  };
};
